export default {
    slider: {
        new: "新的聊天",
        history: "历史记录",
        macro: "宏",
        delete: "删除",
        rename: "重命名",
        pin:"固定",
        unpin:"取消固定",
        },
    homepage:{
      logout: "登出",
    },
    input:{
        api:"API调度",
        knowledge:"知识库查询",
        preWorld:"输入你想问的问题",
        reference:"参考链接:"
    },

    messageRow:{
        reference:"参考链接:",
        copy:"复制",
        good:"回答准确",
        bad:"回答错误",
    },
      
    contextmenu:{
        copy:"复制    Ctrl+X",
        paste:"粘贴    Ctrl+V",
        cut:"剪切    Ctrl+X",
    },

    commandSuggestion:{
        suggestion:"是否执行 {name} 命令?",
      }
  }
  